module.exports = __webpack_public_path__ + "static/media/css3-alt.ac2bf97c.svg";